export enum PermissionType {
  ApprovePreparation = "approvePreparation",
  ApproveReview = "approveReview",
  ApproveSignerReview = "approveSignerReview",
  ApproveClientApproval = "approveClientApproval",
  ApproveEFiling = "approveEFiling",
  ApproveConfirmationReview = "approveConfirmationReview",
}
